import { HYDRATE } from 'next-redux-wrapper';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import * as ActionCreators from '~/src/features/multibundle/store/actionCreators';
import { IVasMultibundle } from '~/src/features/multibundle/store/actions';
import { EMultibundle } from '~/src/features/multibundle/store/actionTypes';
import { InferValueTypes, THydrateAction } from '~/src/store';

export type TStages = 'unknown' | 'reload' | 'error' | 'loaded' | 'loading';

export type TSteps = 'phone' | 'connection' | 'change' | 'disconnection' | 'error' | 'success' | 'fewMoney' | 'invalidPhone' | 'none';

export interface IVasMultibundleInfo extends IVasMultibundle {
    stage: TStages,
}

export interface IActionInPopup {
    isOpen: boolean,
    step: TSteps,
    props: {
        isChangeMode?: boolean,
        description?: string,
        setIsChangeMode?: (isChangeMode: boolean) => void,
    },
    popup: {
        title: string, type: EResultPopupStatus, isLoading: boolean,
    },
}

export interface ISubscriptionState {
    socId: number,
    title: string,
    cost: number,
}

export interface ISelectedExclusive {
    hasExclusive: boolean,
    socId: number,
    title: string,
}

export interface ISubscribePhoneInfo {
    phone?: string,
    contactId?: number,
}

export interface ISubscribeInfo extends ISubscribePhoneInfo {
    isChanged: boolean,
    addedSubscriptions: ISubscriptionState[],
    selectedExclusive: ISelectedExclusive,
}

export interface IMultibundleStore {
    multibundlesInfo: IVasMultibundleInfo,
    popupInfo: IActionInPopup,
    subscribeInfo: ISubscribeInfo,
}

const INITIAL_STATE_POPUP: IActionInPopup = {
    isOpen: false,
    step: 'none',
    props: {
        isChangeMode: false,
        description: '',
    },
    popup: { title: '', type: EResultPopupStatus.DEFAULT, isLoading: false },
};

const INITIAL_STATE: IMultibundleStore = {
    multibundlesInfo: {
        stage: 'unknown',
        activeSubscriptions: [],
        inactiveSubscriptions: {
            exclusive: [],
            nonExclusive: [],
        },
    },
    popupInfo: INITIAL_STATE_POPUP,
    subscribeInfo: {
        isChanged: false,
        addedSubscriptions: [],
        selectedExclusive: { hasExclusive: false, socId: 0, title: '' },
    },
};

type TActions = ReturnType<InferValueTypes<typeof ActionCreators>> | THydrateAction;

const multibundleReducer = (state = INITIAL_STATE, action: TActions): IMultibundleStore => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.multibundle };
        case EMultibundle.VAS_MULTIBUNDLE:
            return {
                ...state,
                multibundlesInfo: action.payload,
            };
        case EMultibundle.SUBSCRIBE_INFO_SET:
            return {
                ...state,
                subscribeInfo: {
                    ...state.subscribeInfo,
                    ...action.payload,
                },
            };
        case EMultibundle.VAS_MULTIBUNDLE_SET_STAGE:
            return {
                ...state,
                multibundlesInfo: {
                    ...state.multibundlesInfo,
                    stage: action.payload,
                },
            };
        case EMultibundle.POPUP_MULTIBUNDLE_SET_CLOSED:
            return {
                ...state,
                popupInfo: INITIAL_STATE_POPUP,
            };
        case EMultibundle.POPUP_MULTIBUNDLE_SET:
            return {
                ...state,
                popupInfo: {
                    isOpen: action.payload.isOpen || state.popupInfo.isOpen,
                    step: action.payload.step || state.popupInfo.step,
                    props: { ...(action.payload.props || state.popupInfo.props) },
                    popup: {
                        title: action.payload.popup?.title || state.popupInfo.popup.title,
                        type: action.payload.popup?.type || state.popupInfo.popup.type,
                        isLoading: action.payload.popup?.isLoading || state.popupInfo.popup.isLoading,
                    },
                },
            };
        default:
            return state;
    }
};

export default multibundleReducer;
